let Util = {
  //是否支持touch
  isTouch : ('ontouchend' in window),
  //toString
  toString : {}.toString,
  // 绑定事件
  bind : function (el, evt, callback){
    return el.addEventListener(evt, callback, false)
  },
  // 解绑事件
  unbind : function (el, evt, fn){
    return el.removeEventListener(evt, fn, false)
  },

  isNull : function (val){
    return val === null
  },

  isArray : Array.isArray || function (val){
    return val && '[object Array]' === this.toString.call(val);
  },

  isObject : function (val){
    return typeof(val) === 'object' && !this.isArray(val) && !this.isNull(val);
  },

  isDomObject : function (val){
    return this.isObject(val) && '[object HTMLBodyElement]' === this.toString.call(val);
  },
  // 不能直接定义，可能取不到
  getBody : function (){
    return document['body'] || document.querySelectorAll('body')[0] || document.querySelectorAll('html')[0];
  },
  showFps : function(){
    let requestAnimationFrame =
        window.requestAnimationFrame || //Chromium
        window.webkitRequestAnimationFrame || //Webkit
        window.mozRequestAnimationFrame || //Mozilla Geko
        window.oRequestAnimationFrame || //Opera Presto
        window.msRequestAnimationFrame || //IE Trident?
        function(callback) { //Fallback function
          window.setTimeout(callback, 1000/60);
        };
    let fps = 0;
    let last = Date.now();
    let step = function(){
      let offset = Date.now() - last;
      fps += 1;
      if( offset >= 1000 ){
        last += offset;
        let sv = document.querySelector('#debug-info-fps').innerHTML = 'FPS : ' + fps;
        fps = 0;
      }
      requestAnimationFrame( step );
    };
    step()
  }
}

export default Util;



/** WEBPACK FOOTER **
 ** ./lib/util.js
 **/